import { AdministrateResourceDeleteButton } from "../../../components/AdministrateResourceDeleteButton";
import { useTableContext } from "../../../components/AdministrateTable";
import { History } from "../../../tools/sandbox/release/History";
import { useDestroyPermission, useUpdatePermission } from "../../../utils";
import { AvailityErrorRuleModal } from "./AvailityErrorRuleModal";

export const AvailityErrorRuleActionCell = ({ row }) => {
  const { refresh, setError, setMessage } = useTableContext();
  const rule = row.original;
  const [canUpdate] = useUpdatePermission("AvailityErrorRule", rule.id);
  const [canDestroy] = useDestroyPermission("AvailityErrorRule", rule.id);

  return (
    <>
      {canUpdate && (
        <AvailityErrorRuleModal
          color="link"
          rule={rule}
          onSaved={() => {
            refresh();
            setMessage(`Updated Availity error rule ${rule.id}.`);
          }}
        />
      )}
      {canDestroy && (
        <AdministrateResourceDeleteButton
          deleteUrl={`/admin/availity_error_rules/${rule.id}`}
          onSuccess={() => {
            refresh();
            setMessage(`Deleted Availity error rule ${rule.id}.`);
          }}
          onError={setError}
        />
      )}
      <History entityName="AvailityErrorRule" subjectId={rule.id} />
    </>
  );
};
